import { Workflow, formatDateToMMDDYYYY } from '@gripp/shared-logic';
import { ReminderAlertType } from '../components/issue/types';

type ReminderDefaultValues = {
  alertType?: ReminderAlertType;
  inputField?: string | number;
  days?: number;
  dayInterval?: number;
  dayIntervalUnit?: string;
  daysStartDate?: string;
  onDate?: string;
  notes?: string;
  atTime?: string;
  timeZone?: string;
};

export const getReminderDefaultValues = (workflow?: Workflow): ReminderDefaultValues => {
  if (!workflow) return {};

  const { name, trigger } = workflow;
  // atTime/timeZone are schedule metadata, not an alternative trigger
  // condition — excluded so they can never be picked up as configKeys[0]
  // below (mirrors alertSummary.tsx's excludedConfigKeys).
  const excludedConfigKeys = ['dayIntervalUnit', 'issueId', 'startDate', 'atTime', 'timeZone'];
  const configKeys = Object.keys(trigger.config)
    .filter((key) => !excludedConfigKeys.includes(key));

  let alertType;
  let inputField;
  let days;
  let dayInterval;
  let dayIntervalUnit;
  let daysStartDate;
  let onDate;
  let notes;
  // Any reminder type may carry a saved fire time (Date/Days/DayInterval all
  // support atTime per alertScheduleService's config table).
  const atTime = trigger.config.atTime;
  const timeZone = trigger.config.timeZone;

  switch (configKeys[0]) {
    case 'onDate':
      if (configKeys.includes('dayInterval')) {
        dayIntervalUnit = trigger.config.dayIntervalUnit;
        dayInterval = trigger.config.dayInterval;
        alertType = ReminderAlertType.DayInterval;
      } else {
        alertType = ReminderAlertType.Date;
      }

      onDate = formatDateToMMDDYYYY(trigger.config.onDate);
      inputField = formatDateToMMDDYYYY(trigger.config.onDate);
      notes = name;
      break;

    case 'every':
      days = trigger.config.every;
      alertType = ReminderAlertType.Days;
      inputField = trigger.config.every;
      daysStartDate = formatDateToMMDDYYYY(trigger.config.startDate);
      notes = name;
      break;

    default:
      break;
  }

  return {
    alertType,
    days,
    daysStartDate,
    inputField,
    notes,
    onDate,
    dayInterval,
    dayIntervalUnit,
    atTime,
    timeZone,
  };
};
